( function ($){

    $ (document).ready (function ($){

        if($('.so-widget-tf-product_big_section .widget_tf-product_big_section').hasClass('no-elements')){
            var element = $('.so-widget-tf-product_big_section .widget_tf-product_big_section.no-elements');
            element.closest('.so-panel').addClass('no-elements');
        }
    });

} ) (jQuery);
